import { IAccount, IGetWorkspaceSwitcherResponseDto } from '@site-mate/sitemate-global-shared';
import { queryOptions } from '@tanstack/react-query';

import { accountService } from '@/services/global-api/account.service';
import { GlobalApiQueryKeys } from '@/services/global-api/constants';
import { workspaceService } from '@/services/global-api/workspace.service';

export const workspaceSwitcherKeys = {
  all: ['workspace-switcher'] as const,
  menu: (isSuperUser: boolean, accountId: string | null | undefined) => [...workspaceSwitcherKeys.all, 'menu', isSuperUser, accountId] as const,
  workspaces: () => [...workspaceSwitcherKeys.all, 'workspaces'] as const,
  workspacesSearch: (search: string) => [...workspaceSwitcherKeys.all, 'workspaces-search', search] as const,
  superuserSearch: (search: string) => [...workspaceSwitcherKeys.all, 'superuser-search', search] as const,
  createWorkspaceAccount: (accountId: string | null) => [...workspaceSwitcherKeys.all, 'create-workspace-account', accountId] as const,
};

export const getWorkspaceSwitcherMenuQueryOptions = ({ isSuperUser, accountId }: { isSuperUser: boolean; accountId: string | null | undefined }) => {
  return queryOptions<IGetWorkspaceSwitcherResponseDto[]>({
    queryKey: workspaceSwitcherKeys.menu(isSuperUser, accountId),
    queryFn: () => (isSuperUser && accountId ? workspaceService.getWorkspacesByAccountId(accountId) : workspaceService.getWorkspacesForRegularUser()),
    staleTime: Infinity,
  });
};

export const getWorkspaceSwitcherWorkspacesQueryOptions = () => {
  return queryOptions({
    queryKey: workspaceSwitcherKeys.workspaces(),
    queryFn: () => workspaceService.getWorkspacesForRegularUser(),
    staleTime: Infinity,
  });
};

export const getWorkspaceSwitcherSearchQueryOptions = ({ search }: { search: string }) => {
  return queryOptions({
    queryKey: workspaceSwitcherKeys.workspacesSearch(search),
    queryFn: () => workspaceService.searchWorkspacesForSuperuser(search),
    enabled: search.length > 0,
  });
};

export const getSuperuserWorkspaceSearchQueryOptions = ({ search }: { search: string }) => {
  return queryOptions({
    queryKey: workspaceSwitcherKeys.superuserSearch(search),
    queryFn: () => workspaceService.searchWorkspacesForSuperuser(search),
    staleTime: 30 * 1000,
  });
};

export const getSitemateStartAccountQueryOptions = ({ accountId }: { accountId: string | null | undefined }) => {
  return queryOptions<IAccount | null>({
    queryKey: [GlobalApiQueryKeys.SitemateStartAccount, { accountId }],
    queryFn: () => {
      if (!accountId) throw new Error('Account ID not found');
      return accountService.getAccountById(accountId);
    },
    enabled: !!accountId,
  });
};

export const getCreateWorkspaceAccountQueryOptions = ({ accountId }: { accountId: string | null }) => {
  return queryOptions<IAccount | null>({
    queryKey: workspaceSwitcherKeys.createWorkspaceAccount(accountId),
    queryFn: () => {
      if (!accountId) throw new Error('accountId is required');
      return accountService.getAccountById(accountId);
    },
    enabled: !!accountId,
  });
};
